import { Country } from '../'

export enum PaymentStatus {
  OWED = 'OWED',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE',
  REFUNDED = 'REFUNDED',
  PARTIAL_REFUND = 'PARTIAL_REFUND',
  DEFERRED = 'DEFERRED',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
}

export enum PaymentSource {
  SCHEDULED_PAYMENTS = 'SCHEDULED_PAYMENTS',
  BUY_PROCESS = 'BUY_PROCESS',
  CONSUMER_PORTAL = 'CONSUMER_PORTAL',
  MERCHANT_PORTAL = 'MERCHANT_PORTAL',
  ADMIN_PORTAL = 'ADMIN_PORTAL',
  COLLECTIONS_SERVICE = 'COLLECTIONS_SERVICE',
  MOBILE_API = 'MOBILE_API',
  POS = 'POS',
  SCHEDULED_FLEX_PAYMENT = 'SCHEDULED_FLEX_PAYMENT',
  CHARGE_AT_SHIP = 'CHARGE_AT_SHIP',
  WAIVED_BY_ADMIN = 'WAIVED_BY_ADMIN',
}

export enum PaymentMethodType {
  CREDIT_CARD = 'CREDIT_CARD',
  DEBT_COLLECTION_AGENCY = 'DEBT_COLLECTION_AGENCY',
  DISCOUNT = 'DISCOUNT',
  APPLE_PAY = 'APPLE_PAY',
  ACH_BANK_ACCOUNT = 'ACH_BANK_ACCOUNT',
  CASH_APP_PAY = 'CASH_APP_PAY',
}

export enum PaymentCreditCardType {
  CREDIT = 'CREDIT',
  DEBIT = 'DEBIT',
  UNDEFINED = 'UNDEFINED',
  EMPTY = 'EMPTY',
  UNRECOGNIZED = 'UNRECOGNIZED',
  PREPAID = 'PREPAID',
}

export enum CardExpiryStatus {
  OK = 'ok',
  EXPIRING_SOON = 'expiring_soon',
  EXPIRED = 'expired',
}

export interface PaymentMethod {
  cardHolderName: string
  maskedPan: string
  expiryYear: number
  expiryMonth: number
  expiryDate: string
  token: string
  cvvRequired: boolean
  preferred: boolean
  cardBrand: string
  countryCode: Country
  id: number
  type: PaymentMethodType
  allowed: boolean
  issuingBank: string
  creditCardType: PaymentCreditCardType
  cardExpiryStatus: CardExpiryStatus | null
}

export type SavedPaymentMethod =
  | {
      id: number
      type: PaymentMethodType.CREDIT_CARD
      maskedPan: string
      expiryDate: string
      cardBrand: string
    }
  | {
      id: number
      type: PaymentMethodType.ACH_BANK_ACCOUNT
      numberMask: string
      issuingBank: string
    }
  | {
      id: number
      type: PaymentMethodType.APPLE_PAY
      maskedPan: string
      cardBrand: string
    }
  | {
      id: number
      type: PaymentMethodType.CASH_APP_PAY
      cashtag: string
    }
